import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar-actions',
  standalone: false,
  template: `<ng-content></ng-content>`,
})
export class SidebarActionsComponent { }
